import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useNavigate } from "react-router-dom";
import { api_path } from "../../shared.js";

export default function ReminderBell({ userId }) {
  const [reminders, setReminders] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const [readIds, setReadIds] = useState([]);

  // โหลดค่าจาก localStorage ตอนเปิดหน้า
  useEffect(() => {
    const savedReadIds = localStorage.getItem("readReminders");
    if (savedReadIds) {
      setReadIds(JSON.parse(savedReadIds));
    }
  }, []);

  // โหลด reminders จาก API ทุก ๆ 60 วินาที
  useEffect(() => {
    const fetchReminders = async () => {
      try {
        const res = await fetch(
          `${api_path}/customer/get-reminder.php?userId=${userId}`
        );
        const data = await res.json();

        // ตรวจสอบว่ามาเป็น array หรือ object
        if (Array.isArray(data)) {
          setReminders(data);
        } else if (data && Array.isArray(data.result)) {
          setReminders(data.result);
        } else {
          setReminders([]);
        }
      } catch (error) {
        console.error("Error loading reminders:", error);
        setReminders([]);
      }
    };

    fetchReminders();
    const interval = setInterval(fetchReminders, 60000);
    return () => clearInterval(interval);
  }, [userId]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickReminder = (id, crm_code) => {
    // ✅ เมื่อคลิกให้บันทึกว่าอ่านแล้ว
    setReadIds((prev) => {
      const newReadIds = prev.includes(id) ? prev : [...prev, id];
      localStorage.setItem("readReminders", JSON.stringify(newReadIds));
      return newReadIds;
    });

    // ✅ อัปเดตทันทีให้ badge ลดลงแบบ realtime
    setReminders((prev) =>
      prev.map((r) => (r.id === id ? { ...r, isRead: true } : r))
    );

    setAnchorEl(null);
    navigate(`/s-crm/Customer?customer_id=${crm_code}&activity_id=${id}`);
  };

  const open = Boolean(anchorEl);

  // ✅ คำนวณเฉพาะจำนวนที่ยังไม่ได้อ่าน
  const unreadCount = reminders.filter((r) => !readIds.includes(r.id)).length;

  return (
    <Box>
      <IconButton color="inherit" onClick={handleClick}>
        <Badge
          badgeContent={unreadCount}
          color="error"
          invisible={unreadCount === 0}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: { width: 320, maxHeight: 500, overflowY: "auto", zIndex: 1100,  },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Reminders
          </Typography>

          {reminders.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No reminders
            </Typography>
          ) : (
            reminders.map((r) => {
              const isRead = readIds.includes(r.id);
              return (
                <Box
                  key={r.id}
                  sx={{
                    mt: 1,
                    p: 1,
                    borderBottom: "1px solid #eee",
                    cursor: "pointer",
                    borderRadius: "6px",
                    backgroundColor: isRead ? "#f5f5f5" : "#e3f2fd",
                    transition: "background-color 0.2s ease",
                    fontSize: "12px",
                  }}
                  onClick={() => handleClickReminder(r.id, r.CRM_CUSCODE)}
                >
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    ⏰ {r.TOPIC}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {r.CUSTOMER_NAME.length > 30
                      ? r.CUSTOMER_NAME.substring(0, 30) + "..."
                      : r.CUSTOMER_NAME}
                  </Typography>
                  <br />
                  <Typography variant="caption" color="text.secondary">
                    {new Date(r.REMINDER).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </Typography>
                </Box>
              );
            })
          )}
        </Box>
      </Popover>
    </Box>
  );
}
